export default function findReport(path) {
  // NOTE: The path for Tracking vs Returns Analytics dashboards
  // are a bit different, MT
  const start = 'report=';
  const end = path.indexOf('&') > -1 ? path.indexOf('&') : path.length;
  let reportName = '';

  if (path.includes(start)) {
    reportName = path.substring(path.indexOf(start) + start.length, end);
  }

  return reportName;
}
